<template>
    <div class="staffStyle">
        <div class="headTitle">
            <div class="shadowTxt">STYLE</div>
            <div class="title">员工风采</div>
        </div>
        <div class="picture">
            <el-carousel arrow='always'>
                <el-carousel-item v-for="(item,index) in cultivate.photo" :key="index">
                    <img :src="'http://www.weaiove.com'+item" alt="" />
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="staffTrain">
            <div class="title">{{cultivate.title}}<span>{{cultivate.engname}}</span></div>
            <div class="text">{{cultivate.content}}</div>
        </div>
         <div class="picture">
            <el-carousel arrow="always">
                <el-carousel-item v-for="(item,index) in demeanour.photo" :key="index">
                <img :src="'http://www.weaiove.com'+item" alt="" />
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="staffTrain">
            <div class="title">{{demeanour.title}}<span>{{demeanour.engname}}</span></div>
            <div class="text">{{demeanour.content}}</div>
        </div>
    </div>
</template>
<script>
import { apiGetStafflist } from "../../api/index";

export default {
    metaInfo: {
        title: '员工风采-爱情地产',
        meta: [{
        name: 'keyWords',
        content: '爱情地产'
        },
        {
        name: 'description',
        content: ''
        }]
    },
  data() {
    return {
      cultivate:[],
      demeanour:[]
    };
  },
  created(){
    apiGetStafflist().then(data=>{
      this. cultivate = data.data.list[0]
      this. demeanour = data.data.list[1]
    })
  }
};
</script>

<style scoped lang='less'>
*{
    margin: 0;
    padding: 0;
}
img{
    width: 100%;
}
.headTitle{
    padding: 20px 15px 7px 15px;
    background: #fff;
    .shadowTxt{
        font-size: 40px;
        line-height: 47px;
        color: #F8F8F8;
        font-family: 'DIN Alternate Bold';
        font-weight: bold;
    }
    .title{
        color: #222;
        font-size: 18px;
        line-height: 25px;
        font-family: '苹方-简 中黑体';
        font-weight: 600;
        margin-top: -28px;
    }
}
.picture {
    margin-top: 21px;
  .el-carousel {
    width: 375px;
    height: 220px;
    /deep/.el-carousel-item{
        height: 220px;
    }
    /deep/.el-carousel__container {
        position: relative;
        width: 100%;
        height: 100%;
    }
    /deep/.el-carousel__arrow--left {
        width: 30px;
        height: 30px;
        background: url('../../assets/images/left.png') no-repeat center/cover;
        i {
        display: none;
        }
    }
    /deep/.el-carousel__arrow--right {
        width: 30px;
        height: 30px;
        background: url('../../assets/images/right.png') no-repeat center/cover;
        i {
        display: none;
        }
    }
    /deep/.el-carousel__indicators{
        display: none;
    }
  }
}
.staffTrain{
    padding: 10px 15px 9px;
    .title{
        font-size: 15px;
        line-height: 21px;
        color: #000;
        font-weight: 600;
        font-family: '苹方-简 中黑体';
        span{
            font-size: 12px;
            line-height: 17px;
            color: #ccc;
            margin-left: 5px;
            font-family: '苹方-简 常规体';
            font-weight: normal;
        }
    }
    .text{
        font-size: 12px;
        line-height: 20px;
        margin-top: 10px;
        color: #666666;
        font-family: '苹方-简 常规体';
    }
}
</style>